import React from "react";

const MIGRATION_HERO_ID = "migration-hero";

export const migrationHeroElementId = MIGRATION_HERO_ID;

/** True while the homepage migration hero is visible in the viewport. */
export const useMigrationHeroInView = (enabled: boolean): boolean => {
  const [inView, setInView] = React.useState(true);

  React.useEffect(() => {
    if (!enabled) {
      setInView(true);
      return;
    }

    const element = document.getElementById(MIGRATION_HERO_ID);

    if (!element) {
      setInView(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [enabled]);

  return inView;
};
